import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '../components/common/PageHeader';
import EligibilityCalculator from '../components/calculator/EligibilityCalculator';

const CalculatorPage = () => {
  return (
    <Box>
      <PageHeader title="Pre-Eligibility Calculator" />
      <EligibilityCalculator />
    </Box>
  );
};

export default CalculatorPage;
